import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

import * as Strings from "../commons/string";
import * as Common from "../commons/common";
import * as Request from "../commons/request";
import * as Utils from "../utils/utils";

import styles from "./Welcome.module.css";
import { useAsyncAxios, utilAxiosWithAppToken } from "../utils/customAxios";
import { useAuthDispatch } from "../provider/AuthProvider";
import { useAlert } from "../provider/AlertProvider";

declare const window: typeof globalThis & {
    Android: any;
};

const customBtnAnim = {
    initial: { backgroundColor: `#fff` },
    animate: {},
    whileHover: { y: -5 },
    whileTap: { y: 5, scale: 0.95 },
    exit: { scale: 0 },
};

const customWelcomeAnim = {
    // initial: { opacity: 0.85 },
    // animate: { opacity: 1 },
    // exit: { opacity: 0 },
    hidden: { opacity: 1, scale: 0 },
    visible: {
        opacity: 1,
        scale: 1,
        transition: {
            delayChildren: 0.3,
            staggerChildren: 0.2,
        },
    },
};

function Welcome() {
    const alert = useAlert();

    const navigate = useNavigate();
    const dispatch = useAuthDispatch();

    const [loginInfo, setLoginInfo] = useState<Common.TypeLogin>();

    useEffect(() => {
        const result = Utils.isPossibleAutoLogin();
        if (result.isPossible && result.email && result.password) {
            setLoginInfo({ email: result.email, password: result.password });
        } else {
            setLoginInfo({ email: "", password: "" });
        }
    }, []);

    useEffect(() => {
        if (loginInfo === undefined) return;

        if (loginInfo.email.length > 0 && loginInfo.password.length > 0) {
            login();
        } else {
            navigate(Common.PAGE_LOGIN);
        }
    }, [loginInfo]);

    const requestLogin = async () => {
        const response = await utilAxiosWithAppToken().post(Request.LOGIN_URL, loginInfo);
        return response.data;
    };

    const { loading, error: errorLogin, data: resultLogin, execute: login } = useAsyncAxios(requestLogin);

    useEffect(() => {
        if (resultLogin === null) return;

        if (
            resultLogin.user.authority !== "ROLE_ADMIN" &&
            resultLogin.user.authority !== "ROLE_MANAGER" &&
            resultLogin.user.authority !== "ROLE_RENT_MANAGER" &&
            resultLogin.user.authority !== "ROLE_B2B_MANAGER"
        ) {
            if (dispatch !== null)
                dispatch({
                    type: "LOGOUT",
                });

            navigate(Common.PAGE_LOGIN, { state: { error: Strings.msg_admin_must } });

            return;
        }

        if (dispatch !== null) {
            dispatch({
                type: "LOGIN_SUCCESS",
                payload: {
                    user: resultLogin.user,
                    token: resultLogin.token,
                },
            });
        }

        // TODO:
        navigate(Common.PAGE_MAIN, { replace: true });
    }, [resultLogin]);

    useEffect(() => {
        if (errorLogin === null) {
            return;
        }
        navigate(Common.PAGE_LOGIN, { replace: true });
    }, [errorLogin]);

    const onBackPressEvent = () => {
        window.Android.closeAppOnBackPress();
    };

    useEffect(() => {
        window.addEventListener("backPressEvent", onBackPressEvent);
        return () => {
            window.removeEventListener("backPressEvent", onBackPressEvent);
        };
    }, []);

    return <motion.div className={styles.wrapper} exit="exit"></motion.div>;
}

export default Welcome;
